import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@material-ui/core';
import cn from 'classnames';
import Modal from 'components/Modals/Modal';
import {DialogAction} from 'routes/App/dashboard/styles';
import ButtonPrimary from 'components/buttons/ButtonPrimary/styles';
import {FlexContainer, FlexItem} from 'components/layout';
import DialogTitle from 'components/DialogTitle/styles';
import {CardsButtonGrid} from 'components/CardsButtonGrid/styles';
import {CardsButton} from 'components/CardsButton/styles';
import {DISCOUNT_TYPE} from 'helpers/constants/discountsV2';
import IconDiscountBogo from 'assets/IconDiscountBogo';
import IconDiscountFixed from 'assets/IconDiscountFixed';
import IconDiscountSpecificItems from 'assets/IconDiscountItem';
import IconDiscountPercent from 'assets/IconDiscountPercent';
import DialogSubTitle from 'components/DialogSubTitle/styles';
import {FEATURE_RESTRICTION_IDS} from 'helpers/constants/restrictions';

const ModalSelectDiscount = ({
  onCloseAction,
  submitAction,
  handleChange,
  getValue,
  allowedServiceFeatures
}) => {
  const selectedDiscountType = getValue('type');
  const selectedRateType = getValue('rate.type');
  const getClassName = (value) =>
    value === selectedDiscountType ||
    (selectedDiscountType === DISCOUNT_TYPE.WHOLE_CART &&
      value === selectedRateType)
      ? 'isActive'
      : null;

  const types = [
    {value: DISCOUNT_TYPE.FIXED},
    {value: DISCOUNT_TYPE.BOGO},
    {value: DISCOUNT_TYPE.SPECIFIC_ITEMS},
    {value: DISCOUNT_TYPE.PERCENTAGE}
  ];

  return (
    <Modal
      classParameter='DialogLg'
      onCloseAction={onCloseAction}
      title={
        <Box>
          <DialogTitle className='marginBottomLg'>
            Create your own discount
          </DialogTitle>
          <DialogSubTitle className='discountsV2'>
            Choose a discount type and configure the discount settings.
          </DialogSubTitle>
        </Box>
      }
      body={
        <>
          <CardsButtonGrid className='CardsButtonGridSelectDiscountV2'>
            {types.map(({value}) => (
              <CardsButton
                key={`DiscountType_${value}`}
                className={cn('CardsButton DiscountsV2', getClassName(value))}
                onClick={(e) => {
                  if (
                    value === DISCOUNT_TYPE.FIXED ||
                    value === DISCOUNT_TYPE.PERCENTAGE
                  ) {
                    handleChange('type', DISCOUNT_TYPE.WHOLE_CART);
                    handleChange('rate.type', value);
                    handleChange('rate.value', null);
                    handleChange('subtotal.min', 0);
                  } else if (value === DISCOUNT_TYPE.BOGO) {
                    handleChange('type', value);
                    handleChange('rate.type', DISCOUNT_TYPE.PERCENTAGE);
                    handleChange('rate.value', 100);
                  } else {
                    handleChange('type', value);
                    handleChange('rate.type', null);
                    handleChange('rate.value', null);
                  }
                  handleChange('isPromotional', true);
                  submitAction(e);
                }}
              >
                {value === DISCOUNT_TYPE.PERCENTAGE && (
                  <FlexContainer className='FlexContainerDiscountBogo'>
                    <IconDiscountPercent />
                    <div className='title'>Percentage Off</div>
                    <div className='description'>
                      Offer a percentage off the entire order (e.g., 20% off
                      orders over $40)
                    </div>
                  </FlexContainer>
                )}
                {value === DISCOUNT_TYPE.BOGO && (
                  <FlexContainer className='FlexContainerDiscountBogo'>
                    <IconDiscountBogo />
                    <div className='title'>Buy one, get one free (BOGO)</div>
                    <div className='description'>
                      Offer a free item when a customer buys a qualifying item
                    </div>
                  </FlexContainer>
                )}
                {value === DISCOUNT_TYPE.SPECIFIC_ITEMS && (
                  <FlexContainer className='FlexContainerDiscountBogo'>
                    <IconDiscountSpecificItems />
                    <div className='title'>Item-Level discount</div>
                    <div className='description'>
                      Discount a specific item by a fixed $ amount or %
                    </div>
                  </FlexContainer>
                )}
                {value === DISCOUNT_TYPE.FIXED && (
                  <FlexContainer className='FlexContainerDiscountBogo'>
                    <IconDiscountFixed />
                    <div className='title'>Fixed amount</div>
                    <div className='description'>
                      Offer a flat-dollar discount on any order (e.g., $5 off a
                      $25+ order)
                    </div>
                  </FlexContainer>
                )}
              </CardsButton>
            ))}
          </CardsButtonGrid>
        </>
      }
    />
  );
};

ModalSelectDiscount.propTypes = {
  onCloseAction: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  allowedServiceFeatures: PropTypes.array.isRequired
};

export default ModalSelectDiscount;
